import React from 'react';

function ElearningStudentArticlePage() {
  return <div>ElearningStudentArticlePage</div>;
}

export default ElearningStudentArticlePage;
